import { render, staticRenderFns } from "./personDetail.vue?vue&type=template&id=5d7aa255"
import script from "./personDetail.vue?vue&type=script&lang=js"
export * from "./personDetail.vue?vue&type=script&lang=js"
import style0 from "./personDetail.vue?vue&type=style&index=0&id=5d7aa255&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports